var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImportIcon = function SvgImportIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.5.2.9-Setup-/-Company-/-Company-details---create-project--view-action",
    transform: "translate(-1004.000000, -642.512412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-action",
    transform: "translate(988.000000, 526.511337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(0.000000, 14.001075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75,6.99999998 L10.5,6.99999998 L10.5,11.7928125 L12.1465625,10.1465625 C12.3431447,9.95979806 12.6527655,9.96376218 12.8445017,10.1554983 C13.0362378,10.3472345 13.040202,10.6568554 12.8534375,10.8534375 L10.3534375,13.3534375 C10.1582019,13.5485452 9.8417981,13.5485452 9.6465625,13.3534375 L7.14656248,10.8534375 C6.95979804,10.6568554 6.96376216,10.3472345 7.15549831,10.1554983 C7.34723446,9.96376218 7.65685534,9.95979806 7.85343749,10.1465625 L9.49999997,11.7928125 L9.49999997,6.99999998 L6.24999998,6.99999998 C5.28393004,7.0010334 4.50103338,7.78393005 4.49999997,8.74999999 L4.49999997,15.25 C4.50103338,16.21607 5.28393004,16.9989666 6.24999998,17 L13.75,17 C14.71607,16.9989666 15.4989666,16.21607 15.5,15.25 L15.5,8.74999999 C15.4989666,7.78393005 14.71607,7.0010334 13.75,6.99999998 Z M10.5,3.49999996 C10.5,3.22385758 10.2761424,2.99999996 10,2.99999996 C9.72385762,2.99999996 9.5,3.22385758 9.5,3.49999996 L9.5,6.99999996 L10.5,6.99999996 L10.5,3.49999996 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImportIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/import-icon.e833813c.svg";
export { ForwardRef as ReactComponent };